<div class="profile_information--mi-container">
  <div class="profile_information--input-container">
    <div class="profile_information--input-label">{{ title }}</div>
    <input
      placeholder="{{ placeholder }}"
      i18n-placeholder
      [(ngModel)]="value"
      class="profile_information--input"
    />
  </div>
</div>
